import React, { ReactNode } from 'react';

import useTranslation from '@/utils/hooks/translation/useTranslation';
import useUserRole from '@/utils/hooks/user/useUserRole';

import PropTypes from 'prop-types';

// Types
import type { RoleType } from '@/lib/user/roles';

// Components
import Tooltip from '@/components/base/Tooltip';

type ButtonWithRequiredRoleTooltipProps = {
    requiredRole: RoleType;
    hasRight?: boolean;
    children: (args: { buttonDisabled: boolean }) => ReactNode;
};

const ButtonWithRequiredRoleTooltip = ({
    requiredRole,
    hasRight = false,
    children
}: ButtonWithRequiredRoleTooltipProps) => {
    const { t } = useTranslation('commons');

    const { currentRole } = useUserRole();

    return (
        <Tooltip
            content={t('tooltips.action_protected_by_role', {
                currentRole: t(`roles.${currentRole}`),
                requiredRole: t(`roles.${requiredRole}`)
            })}
            disabled={hasRight}
            position="top"
            interactive={true}>
            <span>{children({ buttonDisabled: !hasRight })}</span>
        </Tooltip>
    );
};

ButtonWithRequiredRoleTooltip.propTypes = {
    requiredRole: PropTypes.string,
    hasRight: PropTypes.bool,
    children: PropTypes.func
};

export default ButtonWithRequiredRoleTooltip;
